import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

import { keys as analytics } from '@workspace/analytics/keys';
import { keys as email } from '@workspace/email/keys';
import { keys as routes } from '@workspace/routes/keys';

export const env = createEnv({
  extends: [analytics(), routes(), email()],
  server: {
    RECAPTCHA_SECRET_KEY: z.string().min(1)
  },
  client: {
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY: z.string().min(1)
  },
  runtimeEnv: {
    RECAPTCHA_SECRET_KEY: process.env.RECAPTCHA_SECRET_KEY,
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY
  }
});
